import { routesMonitoringRootStore } from '../routes-monitoring-root-store';

const useRouteMonitoringStore = () => routesMonitoringRootStore.getStore();

export default useRouteMonitoringStore;
